export default function generateNumberArrayByRange(min, max) {
    const result = []
    for (let index = 0; index <= Math.abs(min - max); index++) {
        result.push(min + index)
    }

    return result.reverse()
}